import { ReactElement } from 'react';
import { useRouter } from 'next/router';
import { useTheme } from '../../../../hooks';
import { useDispatch, useSelector } from 'react-redux';
import {
  ButtonChildrenPosition,
  ButtonColor,
  ButtonContainer,
  ButtonSize,
  IconBurgerComponent,
  IconCloseV2Component,
  useTranslations,
  useUser,
} from '../../../../features';
import { getFastLinksMenuStatusSelector } from '../fastLinksMenu.selectors';
import { openFastLinksMenu } from '../fastLinksMenu.actions';
import * as S from './fastLinksMenuButton.styled';
import { FastLinksMenuButtonModel } from './fastLinksMenuButton.model';
import { urlService } from '../../../../services';
import { mainPath } from '../../../../constants';
import { Nullable, QueryParams } from '../../../../models';
import {
  canShowFastLinksMenuButton,
  isPromo,
  isPromoCourse,
} from '../fastLinksMenu.helper';

export const FastLinksMenuButtonContainer = ({
  margin,
  isMobile = true,
}: FastLinksMenuButtonModel): Nullable<ReactElement> => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const router = useRouter();
  const { user } = useUser();
  const isHeaderFastLinkMenuHidden = user?.career?.isHeaderFastLinkMenuHidden;
  const translations = useTranslations();
  const { isOpened } = useSelector(getFastLinksMenuStatusSelector);

  const handleClick = () => {
    if (isPromoCourse(router)) {
      router.push({
        pathname: mainPath.promo,
        query: {
          [QueryParams.discountProgram]:
            router.query[QueryParams.discountProgram],
        },
      });
    } else if (isHeaderFastLinkMenuHidden) {
      router.push(urlService.getFullUrlToPage(mainPath.courses, router));
    } else {
      dispatch(openFastLinksMenu(!isOpened));
    }
  };

  return (
    <S.FastLinksMenuButton
      isVisible={canShowFastLinksMenuButton(user, router)}
      margin={margin}
      isMobile={isMobile}
    >
      <ButtonContainer
        onClick={handleClick}
        color={ButtonColor.purple}
        borderRadius={100}
        childrenPosition={ButtonChildrenPosition.left}
        title={translations.catalog}
        size={theme.IS_MOBILE ? ButtonSize.small : ButtonSize.normal}
        children={
          isHeaderFastLinkMenuHidden ||
          isPromo(router) ? undefined : isOpened ? (
            <IconCloseV2Component strokeColor={theme.COLOR.WHITE} />
          ) : (
            <IconBurgerComponent
              strokeWidth={theme.IS_MOBILE ? '2.4' : '1.8'}
              strokeColor={theme.COLOR.WHITE}
            />
          )
        }
      />
    </S.FastLinksMenuButton>
  );
};
